export default __webpack_public_path__ + "b286396c8c0eb476ed09fd229b023bad.png";